import { deepmerge } from '@mui/utils';
import createTheme from './createTheme';
export default function createMuiStrictModeTheme(options, ...args) {
  return createTheme(deepmerge({
    unstable_strictMode: true
  }, options), ...args);
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/material/styles/createMuiStrictModeTheme.js
// module id = 970
// module chunks = 1